import { AdvancedType } from "src/modules/utils/shared/advanced-type";
import { Type } from "class-transformer";
import { EnaioCall } from "./EnaioCall";
import { EnaioUserIdentification } from "./EnaioUserIdentification";

export class EnaioCallGetUserPassword extends EnaioCall <string[]> {
    @Type(() => EnaioUserIdentification)
    user: EnaioUserIdentification;
    getModelType(): AdvancedType {
        return AdvancedType.ofPrimitive("string", 1);
    }

}
